<template v-if="skin">
  <div class="text-xs-center">
    <v-dialog v-model="show" width="550" persistent lazy>
      <v-card class="text-xs-left">
        <v-card-title
          class="headline lighten-2"
          base-title
        >{{ $t('Interchange.Help.Title') }}</v-card-title>
        <v-card-text>
          <div v-html="$t('Interchange.Help.Labels.Definition')"></div>
          <ul>
            <li>
              <p>
                <span v-html="$t('Interchange.Help.Labels.AsteriskDefinition')"></span>
                <a
                  @click="detailsAsterisk = !detailsAsterisk" class="base--text ml-1"
                >{{ detailsAsterisk ? '&laquo; Ocultar detalles' : 'Mas detalles &raquo;' }}</a>
              </p>
              <v-slide-y-transition hide-on-leave>
                <v-card
                  v-if="detailsAsterisk"
                  v-model="detailsAsterisk"
                  flat
                  class="yellow lighten-4 mb-3"
                >
                  <v-card-text v-html="$t('Interchange.Help.Labels.AsteriskExample')"></v-card-text>
                </v-card>
              </v-slide-y-transition>
            </li>
            <li>
              <p>
                <span v-html="$t('Interchange.Help.Labels.QuestionMarkDefinition')"></span>
                <a
                  @click="detailsQuestion = !detailsQuestion" class="base--text ml-1"
                >{{ detailsQuestion ? '&laquo; Ocultar detalles' : 'Mas detalles &raquo;' }}</a>
              </p>
              <v-slide-y-transition hide-on-leave>
                <v-card
                  v-if="detailsQuestion"
                  v-model="detailsQuestion"
                  flat
                  class="yellow lighten-4 mb-3"
                >
                  <v-card-text v-html="$t('Interchange.Help.Labels.QuestionMarkDefinition')"></v-card-text>
                </v-card>
              </v-slide-y-transition>
            </li>
            <li>
              <p>
                <span v-html="$t('Interchange.Help.Labels.AdvancedDefinition')"></span>
                <a
                  @click="detailsAdvanced = !detailsAdvanced" class="base--text ml-1"
                >{{ detailsAdvanced ? '&laquo; Ocultar detalles' : 'Mas detalles &raquo;' }}</a>
              </p>
              <v-slide-y-transition hide-on-leave>
                <v-card
                  v-if="detailsAdvanced"
                  v-model="detailsAdvanced"
                  flat
                  class="yellow lighten-4 mb-3"
                >
                  <v-card-text v-html="$t('Interchange.Help.Labels.AdvancedExample')"></v-card-text>
                </v-card>
              </v-slide-y-transition>
            </li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="skin.primary_color" class="white--text" @click="close">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: "InterchangeHelp",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    detailsAsterisk: false,
    detailsQuestion: false,
    detailsAdvanced: false
  }),
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    })
  },
  methods: {
    close() {
      this.$root.$emit("close-modal", "intHelp");
    }
  }
};
</script>